import { createFileRoute } from '@tanstack/react-router';
import BackupsRemotos from './-component';
import { backupRemotoQueryOptions } from './-queries';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/backups-remotos',
)({
  context: ({ params }) => ({
    backupRemotoQueryOptions: backupRemotoQueryOptions(params.id),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.backupRemotoQueryOptions);
  },
  component: BackupsRemotos,
});
